import { BasketOrderItem } from "../../../../../hooks";
import { CheckoutOrderItem } from "../../../checkoutV2/lib/types";

export const isPromotionalOrderItem = (orderItem: BasketOrderItem) => {
  return Boolean(
    orderItem.promotionAppliedAt || orderItem.PromotionRewardItemId,
  );
};

export const isPromotionalCheckoutOrderItem = (
  checkoutOrderItem: CheckoutOrderItem,
) => {
  return Boolean(
    checkoutOrderItem.promotionAppliedAt ||
    checkoutOrderItem.promotionRewardItemId,
  );
};
